import type { TrackRecordItem } from '../types/content';

export const trackRecord: TrackRecordItem[] = [
  {
    number: '01',
    title: 'Responding to Market & Technological Disruption',
    summary:
      'Guided the organization through the IP and streaming evolution, repositioning legacy broadcast infrastructure ahead of industry-wide technology change.'
  },
  {
    number: '02',
    title: 'Expanding International Market Reach',
    summary:
      'Extended commercial presence across EMEA, the Americas, and APAC, establishing repeatable frameworks for new territory entry.'
  },
  {
    number: '03',
    title: 'Reconfiguring Capability via Strategic Outsourcing',
    summary:
      'Redesigned the operating model and vendor ecosystem to build a leaner, more resilient delivery capability.'
  },
  {
    number: '04',
    title: 'Converting Strategic Alliances into Commercial Leverage',
    summary:
      'Turned high-stakes partnership negotiations into durable commercial advantage across content, technology, and distribution.'
  },
  {
    number: '05',
    title: 'Cross-Functional Execution',
    summary:
      'Partnered across Commercial, Technology, Legal, and Finance to deliver enterprise initiatives to board-level standards.'
  }
];
